module.exports = __webpack_public_path__ + "img/red-tailed-hawk.9ee9c5f6.jpg";